import React from "react";
import {
  ContentContainer,
  HeaderTitle,
  ICON_PROPS,
  ObjectItem,
  ObjectList,
  Panel,
} from "@riag-libs/etax-pattern-library";
import { DefaultButton, PanelType, Text } from "@fluentui/react";
import HttpService from "../../services/HttpService";

export const VonMirGeteiltPanel = (props) => {
  const {
    selectedGroup,
    selectedItem,
    isOpen,
    onDismiss,
    setAcceptedInvitations,
  } = props;

  const getAcceptedInvitationsList = async () => {
    const response = await HttpService.getAxiosClient().post(
      "/api/shares/my/all",
      { lang: "de" }
    );
    if (response.status === 200) {
      setAcceptedInvitations(response.data);
    }
  };

  const handleInvitationDelete = async (invitation) => {
    try {
      const response = await HttpService.getAxiosClient().post(
        "/api/shares/my/delete",
        {
          subjectId: invitation.subjectId,
          subjectType: invitation.type,
          trusteeId: invitation.trustee.userId,
        }
      );
      if (response.status === 200) {
        getAcceptedInvitationsList();
        onDismiss();
      }
    } catch (error) {
      console.log(error, error.message);
    }
  };

  const onRenderFooterContent = React.useCallback(
    () => <DefaultButton onClick={onDismiss}>Schliessen</DefaultButton>,
    [onDismiss]
  );

  if (!selectedGroup || !selectedGroup.trustee) {
    return <div></div>;
  }

  if (!isOpen || !selectedGroup?.trustee) {
    return null;
  }

  return (
    <Panel
      headerText={
        <HeaderTitle
          title={`Von mir geteilt mit ${selectedGroup.trustee.fname} ${selectedGroup.trustee.lname}`}
          subTitle="Geteilte Inhalte"
          logo={ICON_PROPS.ShareIcon}
          className="l-m-b-16"
        />
      }
      className={"owTheme"}
      panelType={PanelType.medium}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onRenderFooterContent={onRenderFooterContent}
      isFooterAtBottom={true}
    >
      <ContentContainer className="vertical">
        <ObjectList
          title="Geteilt mit"
          headingTag="h2"
          headingTagClass="title2"
        >
          <ContentContainer className="vertical l-flex-rowgap-8">
            {selectedGroup.shares.map((invitation) => (
              <ObjectItem
                key={invitation.subjectId}
                className={`whiteContent ${
                  invitation.subjectId === selectedItem?.subjectId
                    ? "selected"
                    : ""
                }`}
              >
                <ContentContainer className="l-flex-column l-flex-align-stretch lineSeparator">
                  <ContentContainer className="l-flex-rowgap-4">
                    <Text
                      as="span"
                      className="flexItem t-standard title4 t-overflow-wrap l-fb-50"
                    >
                      Name:
                    </Text>
                    <Text
                      as="span"
                      className="flexItem t-standard t-overflow-wrap l-fb-50"
                    >
                      {invitation.invitation.fname}{" "}
                      {invitation.invitation.lname}
                    </Text>
                  </ContentContainer>
                  <ContentContainer className="l-flex-rowgap-4">
                    <Text
                      as="span"
                      className="flexItem t-standard title4 t-overflow-wrap l-fb-50"
                    >
                      E-Mail:
                    </Text>
                    <Text
                      as="span"
                      className="flexItem t-standard t-overflow-wrap l-fb-50"
                    >
                      {invitation.invitation.email}
                    </Text>
                  </ContentContainer>
                  <ContentContainer className="l-flex-rowgap-4">
                    <Text
                      as="span"
                      className="flexItem t-standard title4 t-overflow-wrap l-fb-50"
                    >
                      Mobile-Nummer:
                    </Text>
                    <Text
                      as="span"
                      className="flexItem t-standard t-overflow-wrap l-fb-50"
                    >
                      {invitation.invitation.mobile}
                    </Text>
                  </ContentContainer>
                  <ContentContainer className="l-flex-rowgap-4">
                    <Text
                      as="span"
                      className="flexItem t-standard title4 t-overflow-wrap l-fb-50"
                    >
                      Benutzerrechte:
                    </Text>
                    <Text
                      as="span"
                      className="flexItem t-standard t-overflow-wrap l-fb-50"
                    >
                      {invitation.permissions.accountsView &&
                        "Sieht Steuerkonto, Sieht Dokumente"}
                      {invitation.permissions.declRead &&
                        " Deklaration lesen, bearbeiten, übermitteln"}
                    </Text>
                  </ContentContainer>
                </ContentContainer>
                <ContentContainer className="l-m-t-8">
                  <DefaultButton
                    text="Teilen beenden"
                    iconProps={ICON_PROPS.DeleteIcon}
                    onClick={() => handleInvitationDelete(invitation)}
                  />
                </ContentContainer>
              </ObjectItem>
            ))}
          </ContentContainer>
        </ObjectList>
      </ContentContainer>
    </Panel>
  );
};
